// Scroll height check
let winHeight = window.innerHeight;
window.onscroll = function() {scrollCheck()};

function scrollCheck() {
  if (document.body.scrollTop > (winHeight * .75) || document.documentElement.scrollTop > (winHeight * .75)) {
    document.querySelector(".cta-sticky").classList.add("active");
  } else {
    document.querySelector(".cta-sticky").classList.remove("active");
  }
}

// Default Variables 
let pdpSoldOut = false;
let pdpSubscribe = false;
let regPrice;
let subscribePrice;

// If product is OOS, update the sticky CTA accordingly
if(document.querySelector("#NotifyMe")){
  pdpSoldOut = true;
  document.querySelector("#cta-sticky__btn").innerHTML = "Sold Out";
}

// Click function that animates the text in the CTA button (also check OOS messaging)  
document.querySelector("#cta-sticky__btn").addEventListener("click", function(){
    
    if(pdpSoldOut === false){
      document.querySelector("#AddToCart").click();
      document.querySelector("#cta-sticky__btn").innerHTML = "Adding...";
      setTimeout(function(){
        document.querySelector("#cta-sticky__btn").innerHTML = "Add to Bag";
      }, 1000);
    } else {
      document.querySelector("#NotifyMe").click();
    }
});
